export const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:6540';
export const UPLOAD_API_URL = process.env.REACT_APP_UPLOAD_API_URL || '';
export const UPLOAD_API_KEY = process.env.REACT_APP_UPLOAD_API_KEY || '';
